
export const state = {
  integrations: [],
  events: {
    loading: false,
    subscriptions: [],
    subscriptionMessages: {} // { [subscription_id]: [{ data: [...messages], loading: false }] }
  }
}
